/* eslint-disable react/prop-types */
import PT from 'prop-types';

// mui imports
import { Card, Typography, CardContent } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

const ExerciseCard = ({ session, modules, id, type, instance, courseID, links }) => {
  const location = useLocation();
  const routes = location.pathname.split('/');
  let link = '';
  const replaced = val => {
    if (val === undefined) {
      return val;
    } else {
      val = val.toString()?.replace(/\//g, '');
      val = val.toString()?.replace(/\?/g, '');
      return val.toString()?.replace(/ /g, '_');
    }
  };

  if (session?.split(' ').includes('Document')) {
    // console.log(session);
    // console.log(instance);
    link = `/courses/editor/${replaced(session)}-${replaced(instance)}`;
  } else {
    link = `/courses/typing/${replaced(session)}-${replaced(instance)}`;
  }
  return (
    <Card
      sx={{
        background: 'transparent !important',
        boxShadow: 'none !important',
        padding: '0 !important'
      }}>
      <Link
        to={type ? link : `/courses/${routes[routes.length - 1]}/${id}`}
        state={type ? { courseID, links } : { modules, session, courseID, links }}>
        <CardContent
          sx={{
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'space-between',
            paddingBottom: '0 !important'
          }}>
          <Typography
            sx={{
              '&:hover': {
                color: 'orange'
              }
            }}
            color="secondary"
            variant="p"
            as="p"
            align="left">
            {session}
          </Typography>
        </CardContent>
      </Link>
    </Card>
  );
};

ExerciseCard.propTypes = {
  session: PT.string.isRequired
};

export default ExerciseCard;
